import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(loadReservationIfNeeded);

import { fetchEntity } from '@classpass/saga-tools';
import { call } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { cancelReservation, scheduleById } from 'redux/saga/entities/bound';
import { resetEntity } from 'redux/saga/helpers/reset-entity';
export function loadReservationIfNeeded(client, _ref) {
  var reservationId, scheduleId;
  return regeneratorRuntime.wrap(function loadReservationIfNeeded$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          reservationId = _ref.reservationId, scheduleId = _ref.scheduleId;
          _context.next = 3;
          return call(resetEntity, cancelReservation);

        case 3:
          if (!reservationId) {
            _context.next = 5;
            break;
          }

          return _context.abrupt("return");

        case 5:
          _context.prev = 5;
          _context.next = 8;
          return call(fetchEntity, scheduleById, [client, scheduleId]);

        case 8:
          _context.next = 14;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](5);
          _context.next = 14;
          return call(logger.error, 'Could not load reservation data', _context.t0);

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[5, 10]]);
}